export {default as wrapPageElement} from './src/gatsby-common/wrap-page';

export function onClientEntry() {
  console.log('Ocular loaded'); // eslint-disable-line
}
